/* eslint-disable max-classes-per-file */
import { extractUserProperties } from 'hooks/useFacebookPixel';

export class LoggingAnalyticsHandler {
  trackPageView(url) {
    console.log('Analytics page view:', url);
  }
}

// Google Analytics 4 (GA4) using gtag.js script, which is included in util/includeScripts.js
export class GoogleAnalyticsHandler {
  trackPageView(canonicalPath, previousPath) {
    // GA4 property. Manually send page_view events
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    // Note 1: You should turn "Enhanced measurement" off.
    //         It attaches own listeners to elements and that breaks in-app navigation.
    // Note 2: If previousPath is null (just after page load), gtag script sends page_view event automatically.
    //         Only in-app navigation needs to be sent manually from SPA.
    // Note 3: Timeout is needed because gtag script picks up <title>,
    //         and location change event happens before initial rendering.
    if (previousPath && window.gtag) {
      window.setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
        });
      }, 300);
    }
  }
}

export class FacebookPixelHandler {
  constructor({ devMode }) {
    this.devMode = devMode;
  }

  trackPageView(canonicalPath, previousPath, store) {
    // Skip the first render in client side(it's covered by CAPI in server side)
    if (previousPath && window.fbq) {
      const state = store.getState();
      const userProperties = extractUserProperties(state.user.currentUser);
      const properties = { ...userProperties, agent: navigator.userAgent };
      if (this.devMode) {
        console.log('Facebook Pixel page view:', canonicalPath, properties);
      }
      window.fbq('track', 'PageView', properties);
    }
  }
}
